import type { VisibilityRow } from '@/lib/schemas/visibility'

export type VisibilityFilter = 'all' | 'divergent' | 'sellable' | 'not-sellable'

/**
 * All / Divergent only (divergent) / Sellable (inventory_policy CONTINUE) /
 * Not sellable (inventory_policy DENY). Sellable state is Shopify's
 * inventory_policy, the authoritative field.
 */
export function filterByCategory(
  rows: VisibilityRow[],
  filter: VisibilityFilter,
): VisibilityRow[] {
  switch (filter) {
    case 'divergent':
      return rows.filter((r) => r.divergent)
    case 'sellable':
      return rows.filter((r) => r.inventory_policy === 'CONTINUE')
    case 'not-sellable':
      return rows.filter((r) => r.inventory_policy === 'DENY')
    default:
      return rows
  }
}

/** Case-insensitive substring match on product title, SKU, or EAN. */
export function searchRows(rows: VisibilityRow[], query: string): VisibilityRow[] {
  const q = query.trim().toLowerCase()
  if (!q) return rows
  return rows.filter(
    (r) =>
      r.product_title.toLowerCase().includes(q) ||
      r.sku.toLowerCase().includes(q) ||
      (r.ean != null && r.ean.toLowerCase().includes(q)),
  )
}
